import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyListComponent } from './company-list/company-list.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { CreateCompanyComponent } from './create-company/create-company.component';
import { EditCompanyComponent } from './edit-company/edit-company.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { RouterModule } from '@angular/router';
import { HeaderModule } from 'src/app/header/header.module';



@NgModule({
  declarations: [CompanyListComponent, CreateCompanyComponent, CompanyDetailsComponent, EditCompanyComponent],
  imports: [
    BrowserModule,
    CommonModule,
    NgbModule,
    FormsModule,
    RouterModule,
    HeaderModule
  ]
})
export class CompanyManagementModule { }
